import { render, staticRenderFns } from "./cascader-popover.vue?vue&type=template&id=3bf58900&scoped=true&"
import script from "./cascader-popover.vue?vue&type=script&lang=js&"
export * from "./cascader-popover.vue?vue&type=script&lang=js&"
import style0 from "./cascader-popover.vue?vue&type=style&index=0&id=3bf58900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf58900",
  null
  
)

export default component.exports